export function IconClose({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m.97 12.47 12-12 1.06 1.06-12 12-1.06-1.06Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m14.03 12.47-12-12L.97 1.53l12 12 1.06-1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
